export default {
	"coupon.TheCouponHasExpiredAndTheCampaignIsInvalid": "優惠券已失效，活動無效"
}